import { render, staticRenderFns } from "./riderOrderDetail.vue?vue&type=template&id=7a924f41&scoped=true"
import script from "./riderOrderDetail.vue?vue&type=script&lang=js"
export * from "./riderOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./riderOrderDetail.vue?vue&type=style&index=0&id=7a924f41&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a924f41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a924f41')) {
      api.createRecord('7a924f41', component.options)
    } else {
      api.reload('7a924f41', component.options)
    }
    module.hot.accept("./riderOrderDetail.vue?vue&type=template&id=7a924f41&scoped=true", function () {
      api.rerender('7a924f41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryEffiRider/riderOrderDetail.vue"
export default component.exports